// react and mui stuff
import { useContext } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";

import IconButton from "@mui/joy/IconButton";
import CssBaseline from "@mui/joy/CssBaseline";
import { CssVarsProvider } from "@mui/joy/styles";

import FullscreenExit from "@mui/icons-material/FullscreenExit";

// custom components
import { MetaProps } from "../../components/metaprops";
import DPad from "./dpad";
import Trusted from "./trusted";
import Door from "./door";

// data and stuff
import { CliUser } from "../../types/users";
import { imgSrc } from "../../utils/backend";
import { UserContext } from "../../utils/contexts";

function router(user: CliUser) {
  if (!user.perms.isTrusted) {
    return <Route path="trusted" element={<Trusted/>}/>
  } else if (user.perms.inHouse) {
    return <Route path="dpad" element={<DPad/>}/>
  } else {
    return <Route path="door" element={<Door/>}/>
  }
}

export default function DaedalusIndex() {
  const {user} = useContext(UserContext)
  const nav = useNavigate()
  const loc = useLocation();

  // const metadata = <MetaProps
  //   title="Daedalus"
  //   url="daedalus3"
  //   description="Discover your true allegiance by being sorted into one of the three houses; Brightbeam, Freshbeast, or Starcamp. Use the keypad to enter secret codes and unlock hidden information tailored to your house's unique journey."
  //   splash="houses"
  // />

  if (!user) return <MetaProps path={loc.pathname}/>

  const route = user.perms.isTrusted ? user.perms.inHouse ? "/dpad" : "/door" : "/trusted";
  const style: React.CSSProperties = { position: "fixed", top: 0, left: 0, height: "100vh", width: "100vw", overflow: "hidden", objectFit: "cover", zIndex: -1, animation: "fade-in 1s" }

  return (
    <div style={{width: "100vw", height: "100vh", overflow: "auto" }} data-joy-color-scheme="dark">
      <MetaProps path={loc.pathname}/>
      <IconButton sx={{ position: "fixed", right: "15px", top: "15px", zIndex: 100 }} onClick={() => nav("/profile")} aria-label="Return to profile">
        <FullscreenExit fontSize="large"/>
      </IconButton>

      {/** Cool background ^ (plus make it auto dark theme) */}
      <CssVarsProvider>
        <CssBaseline/>

        <Routes>
          {router(user)}
          <Route path="/*" element={<Navigate to={`/daedalus3${route}`}/>}/>
        </Routes>
      </CssVarsProvider>

      {/** Flying particles, yipee! */}
      <div>
        <div className="ember" aria-disabled tabIndex={-1}/>
        <div className="ember" aria-disabled tabIndex={-1}/>
        <div className="ember" aria-disabled tabIndex={-1}/>
        <div className="ember" aria-disabled tabIndex={-1}/>
        <div className="ember" aria-disabled tabIndex={-1}/>
        <div className="ember" aria-disabled tabIndex={-1}/>
        <div className="ember" aria-disabled tabIndex={-1}/>
        <div className="ember" aria-disabled tabIndex={-1}/>
        <div className="ember" aria-disabled tabIndex={-1}/>
        <div className="ember" aria-disabled tabIndex={-1}/>
        <div className="ember" aria-disabled tabIndex={-1}/>
        <div className="ember" aria-disabled tabIndex={-1}/>
        <div className="ember" aria-disabled tabIndex={-1}/>
        <div className="ember" aria-disabled tabIndex={-1}/>
      </div>

      {/** Background */}
      <picture style={{ zIndex: -1 }}>
        <source width="100vw" height="100vh" style={style} srcSet={`${imgSrc("background.webp")}, ${imgSrc("background_2x.webp")} 2x`} type="image/webp"/>
        <source width="100vw" height="100vh" style={style} srcSet={`${imgSrc("background_2x.jpg")} 2x`}/>
        <img width="100vw" height="100vh" style={style} src={imgSrc("background.jpg")} alt=""/>
      </picture>
    </div>
  )
}